module.exports = __webpack_public_path__ + "img/htkj_07.8fc90cda.jpg";